import { getCustomDeviceId, securelyCacheData, securelyDeleteData, securelyRetrieveData } from "../utils";
import { GlobalDialogType, StoreStateType } from "./types";
import { create } from 'zustand';
import { AddBankBeneficiaryRequest, AddSkypayBeneficiaryRequest, AddWalletBeneficiaryRequest, CancelAddBankBeneficiaryDemandeRequest, CancelAddSkypayBeneficiaryDemandeRequest, CancelAddWalletBeneficiaryDemandeRequest, CancelBankTransactionDemandeRequest, CancelSkypayTransactionDemandeRequest, CancelWalletTransactionDemandeRequest, CashInCashRequest, CashOutRequest, ChangeDeliveryMemberDetailsRequest, ChangeDeliveryMemberStatusRequest, ChangePasswordRequest, ChangeTeamMemberDetailsRequest, ChangeTeamMemberStatusRequest, CheckBeneficiaryHasSkypayAccountRequest, CreateDeliveryMemberRequest, CreateUserRequest, DeleteBankBeneficiaryRequest, DeleteSkypayBeneficiaryRequest, DeleteWalletBeneficiaryRequest, FetchAllDeliveryMembersRequest, FetchAllUsersPageRequest, FetchActivityPerProfessionalDeliveryAgentRequest, FetchQrCodeSectionKPIOverviewRequest, FetchReversementSectionKPIOverviewRequest, ForgotPasswordConfirmationRequest, ForgotPasswordGenerateOtpRequest, ForgotPasswordValidateOtpRequest, GenerateOtpM2TRequest, GetAddBankBeneficiaryDemandesPageRequest, GetAddSkypayBeneficiaryDemandesPageRequest, GetAddWalletBeneficiaryDemandesPageRequest, GetBankBeneficiariesPageRequest, GetBankTransactionDemandesPageRequest, GetCashOutFeesRequest, GetSkypayBeneficiariesPageRequest, GetSkypayBeneficiaryInfosRequest, GetSkypayTransactionDemandesPageRequest, GetUserActiveAddBankBeneficiaryDemandesPageRequest, GetUserActiveAddSkypayBeneficiaryDemandesPageRequest, GetUserActiveAddWalletBeneficiaryDemandesPageRequest, GetUserActiveBankTransactionDemandesPageRequest, GetUserActiveSkypayTransactionDemandesPageRequest, GetUserActiveWalletTransactionDemandesPageRequest, GetWalletBeneficiariesPageRequest, GetWalletTransactionDemandesPageRequest, LoginGenerateOtpRequest, LoginRequest, LoginValidateOtpRequest, ReportDocumentRequest, RequestAddBankBeneficiaryRequest, RequestAddSkypayBeneficiaryRequest, RequestAddWalletBeneficiaryRequest, RequestSendMoneyToBankRequest, RequestSendMoneyToSkypayRequest, RequestSendMoneyToWalletRequest, SendMoneyToBankRequest, SendMoneyToSkypayRequest, SendMoneyToWalletRequest, UpdateAvatarRequest, FetchDeliveryFinancialSituationRequest, FetchAllDeliveryMemberCollectionsRequest, cancelDeliveryMemberCollectionRequest, FetchAllDeliveryMemberReversmentsRequest, FetchReversmentsIncludedCollectionsRequest } from "./types/requests";
import instance from "service";
import { cancelDeliveryMemberCollectionResponse, CashInCashResponse, CashOutResponse, FetchAllDeliveryMemberCollectionsResponse, FetchAllDeliveryMemberReversmentsResponse, FetchAllDeliveryMembersResponse, FetchDeliveryFinancialSituationResponse, FetchReversmentsIncludedCollectionsResponse, GenerateOtpM2TResponse, GetAddBankBeneficiaryDemandesPageResponse, GetAddSkypayBeneficiaryDemandesPageResponse, GetAddWalletBeneficiaryDemandesPageResponse, GetBankTransactionDemandesPageResponse, GetCashOutFeesResponse, GetSkypayBeneficiaryInfosResponse, GetSkypayTransactionDemandesPageResponse, GetWalletTransactionDemandesPageResponse, OTPValidationResponse, QrCodeDocumentResponse, ReportDocumentResponse, RibDocumentResponse, TokenResponse } from "./types/responses";
import { CHANGE_PASSWORD, CREATE_USER, FETCH_ALL_USERS, FORGOT_PASSWORD_CONFIRMATION, FORGOT_PASSWORD_GENERATE_OTP, FORGOT_PASSWORD_VALIDATE_EMAIL_OTP, GET_LOGGED_USER_DETAILS, LOGIN_GENERATE_OTP, LOGIN_VALIDATE_OTP, LOGIN_VERIFY_CREDENTIALS, LOGOUT, CHANGE_TEAM_MEMBER_STATUS, CHANGE_TEAM_MEMBER_DETAILS, GET_ACCOUNT_DETAILS, GET_RIB_DOCUMENT, GENERATE_M2T_OTP, CASH_IN_CASH, CASH_OUT_CASH, GET_FEES_CASHOUT_CASH, PENDING_COUNT, PENDING_TRANSACTIONS_HISTORY, GET_BANK_BENEFICIARIES, REQUEST_ADD_BANK_BENEFICIARIES, ADD_BANK_BENEFICIARIES, DELETE_BANK_BENEFICIARIES, GET_SEND_MONEY_TO_BANK_FEES, SEND_MONEY_TO_BANK, REQUEST_SEND_MONEY_TO_BANK, GET_WALLET_BENEFICIARIES, REQUEST_ADD_WALLET_BENEFICIARIES, ADD_WALLET_BENEFICIARIES, DELETE_WALLET_BENEFICIARIES, GET_SEND_MONEY_TO_WALLET_FEES, SEND_MONEY_TO_WALLET, REQUEST_SEND_MONEY_TO_WALLET, CHECK_BENEFICIARY_HAS_SKYPAY_ACCOUNT, GET_SKYPAY_BENEFICIARY_INFOS, GET_SKYPAY_BENEFICIARIES, REQUEST_ADD_SKYPAY_BENEFICIARIES, REQUEST_SEND_MONEY_TO_SKYPAY, SEND_MONEY_TO_SKYPAY, DELETE_SKYPAY_BENEFICIARIES, ADD_SKYPAY_BENEFICIARIES, GET_REQUESTS_COUNT, GET_ADD_SKYPAY_BENEFICIARIES_REQUESTS, GET_ADD_BANK_BENEFICIARIES_REQUESTS, GET_ADD_WALLET_BENEFICIARIES_REQUESTS, GET_SKYPAY_TRANSACTION_REQUESTS, GET_BANK_TRANSACTION_REQUESTS, GET_WALLET_TRANSACTION_REQUESTS, ACCEPT_ADD_SKYPAY_BENEFICIARIES_REQUEST, ACCEPT_ADD_BANK_BENEFICIARIES_REQUEST, ACCEPT_ADD_WALLET_BENEFICIARIES_REQUEST, ACCEPT_SKYPAY_TRANSACTION_REQUEST, ACCEPT_BANK_TRANSACTION_REQUEST, ACCEPT_WALLET_TRANSACTION_REQUEST, REJECT_ADD_SKYPAY_BENEFICIARIES_REQUEST, REJECT_ADD_BANK_BENEFICIARIES_REQUEST, REJECT_ADD_WALLET_BENEFICIARIES_REQUEST, REJECT_SKYPAY_TRANSACTION_REQUEST, REJECT_BANK_TRANSACTION_REQUEST, REJECT_WALLET_TRANSACTION_REQUEST, GENERATE_QR_CODE, DOWNLOAD_QR_CODE, GET_TOKEN_FROM_REFRESH_TOKEN, TRANSACTIONS_HISTORY, GET_USER_ACTIVE_REQUESTS_COUNT, GET_USER_ACTIVE_ADD_SKYPAY_BENEFICIARIES_REQUESTS, GET_USER_ACTIVE_ADD_BANK_BENEFICIARIES_REQUESTS, GET_USER_ACTIVE_ADD_WALLET_BENEFICIARIES_REQUESTS, GET_USER_ACTIVE_SKYPAY_TRANSACTION_REQUESTS, GET_USER_ACTIVE_BANK_TRANSACTION_REQUESTS, GET_USER_ACTIVE_WALLET_TRANSACTION_REQUESTS, CANCEL_ADD_SKYPAY_BENEFICIARIES_REQUEST, CANCEL_ADD_BANK_BENEFICIARIES_REQUEST, CANCEL_ADD_WALLET_BENEFICIARIES_REQUEST, CANCEL_SKYPAY_TRANSACTION_REQUEST, CANCEL_BANK_TRANSACTION_REQUEST, CANCEL_WALLET_TRANSACTION_REQUEST, CHECK_SWITCH_STATUS, SWITCH_ENROLEMENT_GENERATE_OTP, SWITCH_CONFIRM_ENROLEMENT, CHECK_OFFUS_DESTINATION, CHECK_INTERNAL_SWITCH_STATUS, INTERNAL_SWITCH_ENROLEMENT, UPDATE_AVATAR, GET_ALL_DELIVERY_MEMBERS, CREATE_DELIVERY_MEMBER, UPDATE_DELIVERY_MEMBER_STATUS, UPDATE_DELIVERY_MEMBER, GENERATE_REPORT_DOCUMENT, GET_REVERSEMENT_KPI_OVERVIEW, GET_QR_CODE_KPI_OVERVIEW, GET_ACTIVITY_PER_PROFESSIONAL_DELIVERY_AGENT, GET_DELIVERY_FINANCIAL_SITUATION, GET_ALL_DELIVERY_MEMBER_COLLECTIONS, CANCEL_DELIVERY_MEMBER_COLLECTION, GET_ALL_DELIVERY_MEMBER_REVERSMENTS, GET_REVERSEMENT_INCLUDED_COLLECTIONS } from "service/paths";
import { CustomAccessTokenPayload } from "types/AccessTokenPayload";
import { jwtDecode } from "jwt-decode";
import { BankBeneficiaryType, FeeObjectType, PendingTransactionObjectType, SkypayBeneficiaryType, WalletBeneficiaryType, RequestsCountType, ConfirmedTransactionObjectType, SwitchStatus, InternalSwitchStatus, SectionStatus } from "types";
import { addOneDay, checkDates, getSwitchStatusByCode } from "utils/utils";

export const initState = (() => {
    let cachedData = securelyRetrieveData('loggedUser');
    let isRememberMeCached = securelyRetrieveData('rememberMeFields') !== undefined;
    return {
        isLogged: cachedData !== undefined ? true : false,
        pendingTransactions: new Array<PendingTransactionObjectType>(),
        totalPendingTransactionsPaginated: 0,
        totalPendingTransactions: 0,
        pendingTransactionLimit: 10,
        transactions: new Array<ConfirmedTransactionObjectType>(),
        totalTransactions: 0,
        transactionLimit: 5,
        loggedUser: {
            email: "",
            firstName: "",
            lastName: "",
            phoneNumber: "",
            officePhoneNumber: "",
            role: cachedData !== undefined ? cachedData.role : "",
            cin: "",
            hasToChangePassword: false,
            address: {
                street: "",
                street2: "",
                city: "",
                country: "",
                zipCode: "",
            },
            creationDate: new Date(),
            updateDate: new Date(),
        },
        professionalAccount: {
            walletPhoneNumber: '',
            rib: '',
            balance: '',
            avatar: '',
            companyName: '',
            deliverySectionStatus: SectionStatus.INACTIVE,
            analyticsSectionStatus: SectionStatus.INACTIVE,
        },
        globalDialog: {
            isOpen: false,
            title: '',
            description: ''
        },
        rememberMe: isRememberMeCached,
        qrCode: '',
        switchStatus: SwitchStatus.UNKNOWN,
        internalSwitchStatus: InternalSwitchStatus.NOTACTIVE,
        hasSwitchStatusBeenTriedFetching: false,
        hasInternalSwitchStatusBeenTriedFetching: false,
    };
})();

const useStore = create<StoreStateType>((set, get) => ({
    isLogged: initState.isLogged,
    pendingTransactions: initState.pendingTransactions,
    totalPendingTransactionsPaginated: initState.totalPendingTransactionsPaginated,
    totalPendingTransactions: initState.totalPendingTransactions,
    pendingTransactionLimit: initState.pendingTransactionLimit,
    transactions: initState.transactions,
    totalTransactions: initState.totalTransactions,
    transactionLimit: initState.transactionLimit,
    globalDialog: initState.globalDialog,
    loggedUser: initState.loggedUser,
    isFetching: false,
    isFetchingWithReplacingView: false,
    userDidActionLock: false,
    loggedTimeout: undefined,
    rememberMe: initState.rememberMe,
    professionalAccount: initState.professionalAccount,
    qrCode: initState.qrCode,
    switchStatus: initState.switchStatus,
    internalSwitchStatus: initState.internalSwitchStatus,
    hasSwitchStatusBeenTriedFetching: initState.hasSwitchStatusBeenTriedFetching,
    hasInternalSwitchStatusBeenTriedFetching: initState.hasInternalSwitchStatusBeenTriedFetching,

    setIsLogged: (isLogged: boolean) => set((state: StoreStateType) => ({ ...state, isLogged })),

    removeglobalDialog: async () => {
        set((state: StoreStateType) => ({
            ...state,
            globalDialog: {
                isOpen: false,
                title: "",
                description: "",
                actionTitle: "",
                action: () => { },
            }
        }))
    },

    setGlobalDialog: (globalDialog: GlobalDialogType) => {
        set((state: StoreStateType) => ({ ...state, globalDialog }));
    },

    setIsFetching: (isFetching: boolean) => set((state: StoreStateType) => ({ ...state, isFetching })),

    setIsFetchingWithReplacingView: (isFetchingWithReplacingView: boolean) => set((state: StoreStateType) => ({
        ...state,
        isFetchingWithReplacingView
    })),

    setUserDidActionLock: (value: boolean) => set((state: StoreStateType) => ({
        ...state,
        userDidActionLock: value
    })),

    setLoggedTimeout: (value: NodeJS.Timeout) => set((state: StoreStateType) => ({
        ...state,
        loggedTimeout: value
    })),

    setRememberMe: (rememberMe: boolean) => set((state: StoreStateType) => ({
        ...state,
        rememberMe: rememberMe
    })),

    getTokenFromRefreshToken: async (callback: (isSuccess: boolean) => void, doNotRetry?: boolean) => {
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            callback(false)
        } else {
            await instance.post(GET_TOKEN_FROM_REFRESH_TOKEN, {
                refreshToken: cachedData.refreshToken
            }, {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            }).then((Res) => {
                get().saveToken(Res.data.authenticationSuccessResponse);
                callback(true);
            }).catch(async Exp => {
                if (doNotRetry)
                    callback(false)
                else
                    await get().getTokenFromRefreshToken(callback, true);
            })
        }
    },

    verifyCredentials: async (loginRequest: LoginRequest, callback: (operationHash: string) => void) => {
        const deviceId = getCustomDeviceId();
        get().setIsFetching(true);
        await instance.post(LOGIN_VERIFY_CREDENTIALS, { ...loginRequest, deviceId: deviceId }).then((Res) => {
            if ("professionalUserOperationHashResponse" in Res.data) {
                callback(Res.data.professionalUserOperationHashResponse.operationHash)
            } else {
                get().saveToken(Res.data.authenticationSuccessResponse);
                if (get().rememberMe) {
                    securelyCacheData("rememberMeFields", {
                        professionalClientPhoneNumber: loginRequest.professionalClientPhoneNumber,
                        email: loginRequest.email
                    });
                } else {
                    securelyDeleteData("rememberMeFields");
                }
            }
        }).catch(Exp => {
            set(state => ({
                ...state,
                globalDialog: {
                    isOpen: true,
                    title: "Oups, une erreur s'est produite !",
                    description: "Une erreur s'est produite lors du traitement. Veuillez réessayer."
                }
            }))
        })
        get().setIsFetching(false);
    },

    loginGenerateOtp: async (loginGenerateOtpRequest: LoginGenerateOtpRequest, callback: (hash: string | null) => void) => {
        get().setIsFetching(true);
        await instance.post(LOGIN_GENERATE_OTP, loginGenerateOtpRequest).then((Res) => {
            callback(Res.data.operationHash);
        }).catch(Exp => {
            set(state => ({
                ...state,
                globalDialog: {
                    isOpen: true,
                    title: "Oups, une erreur s'est produite !",
                    description: "Échec de la génération du code OTP. Veuillez réessayer."
                }
            }))
        })
        get().setIsFetching(false);
    },

    loginValidateOtp: async (loginValidateOtpRequest: LoginValidateOtpRequest) => {
        get().setIsFetching(true);
        await instance.post(LOGIN_VALIDATE_OTP, loginValidateOtpRequest).then((Res) => {
            get().saveToken(Res.data.authenticationSuccessResponse);
            if (get().rememberMe) {
                securelyCacheData("rememberMeFields", {
                    professionalClientPhoneNumber: loginValidateOtpRequest.professionalClientPhoneNumber,
                    email: loginValidateOtpRequest.email
                });
            } else {
                securelyDeleteData("rememberMeFields");
            }
        }).catch(Exp => {
            set(state => ({
                ...state,
                globalDialog: {
                    isOpen: true,
                    title: "Oups, une erreur s'est produite !",
                    description: "OTP est incorrect. Veuillez réessayer/générer un nouveau code OTP !"
                }
            }))
        })
        get().setIsFetching(false);
    },

    saveToken: (authenticationResponse: TokenResponse) => {
        set((state: StoreStateType) => ({
            ...state,
            loggedUser:
            {
                ...state.loggedUser,
                role: (jwtDecode(authenticationResponse.token) as CustomAccessTokenPayload).roles[0]
            }
        }));
        securelyCacheData("loggedUser", Object.assign(authenticationResponse, {
            date: new Date().getTime(),
            role: (jwtDecode(authenticationResponse.token) as CustomAccessTokenPayload).roles[0]
        }));
        get().setIsLogged(true);
    },

    logout: async () => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, une erreur s'est produite !", description: "Échec de la déconnexion. Veuillez réessayer." }
            }))
            get().logoutFront();
        }
        await instance.post(LOGOUT, {}, {
            headers: {
                Authorization: 'Bearer ' + cachedData.token
            }
        }).then(Res => { }).catch(Exp => {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, une erreur s'est produite !", description: "Échec de la déconnexion. Veuillez réessayer." }
            }))
        }).finally(() => {
            get().logoutFront();
        });
        get().setIsFetching(false);
    },

    logoutFront: () => {
        set(state => ({
            ...initState
        }));
        securelyDeleteData("loggedUser");
        get().setIsLogged(false);
    },

    forgotPasswordGenerateOtp: async (forgotPasswordGenerateOtpRequest: ForgotPasswordGenerateOtpRequest, callBack: (hash: string | null, err?: any) => void) => {
        get().setIsFetching(true);
        await instance.post(FORGOT_PASSWORD_GENERATE_OTP, forgotPasswordGenerateOtpRequest).then((Res) => {
            callBack(Res.data.operationHash)
        }).catch(Exp => {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, une erreur s'est produite !", description: "Échec de la génération du code OTP. Veuillez réessayer." }
            }))
        })
        get().setIsFetching(false);
    },

    forgotPasswordValidateEmailOtp: async (forgotPasswordValidateOtpRequest: ForgotPasswordValidateOtpRequest, callBack: (response: OTPValidationResponse, err?: any) => void) => {
        get().setIsFetching(true);
        await instance.post(FORGOT_PASSWORD_VALIDATE_EMAIL_OTP, forgotPasswordValidateOtpRequest).then((Res) => {
            callBack(Res.data)
        }).catch(Exp => {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, une erreur s'est produite !", description: "OTP est incorrect. Veuillez réessayer/générer un nouveau code OTP !" }
            }))
        })
        get().setIsFetching(false);
    },

    forgotPasswordConfirmation: async (forgotPasswordConfirmationRequest: ForgotPasswordConfirmationRequest, callBack: () => void) => {
        get().setIsFetching(true);
        await instance.post(FORGOT_PASSWORD_CONFIRMATION, forgotPasswordConfirmationRequest).then(async (Res) => {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Mot de passe modifié avec succès !", description: "Veuillez essayer de vous connecter avec votre nouveau mot de passe !" }
            }))
            callBack();
        }).catch(Exp => {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, une erreur s'est produite !", description: "Impossible de réinitialiser le mot de passe, veuillez réessayer." }
            }))
        })
        get().setIsFetching(false);
    },

    getLoggedUserDetails: async () => {
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({ ...state, globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Création du membre échouée. Veuillez réessayer." } }))
            get().logoutFront();
        }
        else {
            await instance.post(GET_LOGGED_USER_DETAILS, {}, {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            }).then(Resp => {
                set(state => ({ ...state, loggedUser: Resp.data }))
            }).catch(Exp => set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Une erreur est survenue. Veuillez réessayer."
                }
            })))
        }
    },

    createUser: async (createUserRequest: CreateUserRequest, callBack: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({ ...state, globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Création du membre échouée. Veuillez réessayer." } }))
            get().logoutFront();
        }
        else
            await instance.post(CREATE_USER, createUserRequest, {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            })
                .then(Resp => {
                    set(state => ({ ...state, globalDialog: { isOpen: true, title: "Création du membre réussie !", description: "Membre créé avec succès" } }))
                    callBack();
                })
                .catch(Exp => set(state => ({ ...state, globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Création du membre échouée. Veuillez réessayer." } })))
        get().setIsFetching(false);
    },

    changePassword: async (changePasswordRequest: ChangePasswordRequest) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Une erreur est survenue. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        }
        else
            await instance.post(CHANGE_PASSWORD, changePasswordRequest, {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            }).then(Res => {
                set((state: StoreStateType) => ({
                    ...state,
                    loggedUser: {
                        ...state.loggedUser,
                        hasToChangePassword: false
                    }
                }));
                get().logoutFront();
            }).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, une erreur s'est produite !",
                        description: "Échec du changement du mot de passe. Veuillez réessayer."
                    }
                }))
            })
        get().setIsFetching(false);
    },

    fetchAllUsers: async (fetchAllUsersPageRequest: FetchAllUsersPageRequest, callback: (response: any) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Une erreur est survenue. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        }
        await instance.post(FETCH_ALL_USERS,
            {
                ...fetchAllUsersPageRequest,
                dateInterval: checkDates([fetchAllUsersPageRequest.dateInterval[0], addOneDay(fetchAllUsersPageRequest.dateInterval[1])])
            },
            {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            }).then(Res => {
                callback(Res.data);
            }).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, une erreur s'est produite !",
                        description: "Échec du chargement de la liste des utilisateurs. Veuillez réessayer."
                    }
                }))
            })
        get().setIsFetching(false);
    },

    changeTeamMemberStatus: async (callback: (response: any) => void, changeTeamMemberStatus: ChangeTeamMemberStatusRequest) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du changement du statut du membre de l'équipe, veuillez réessayer." }
            }))
            get().logoutFront();
        } else await instance.post(CHANGE_TEAM_MEMBER_STATUS, {
            email: changeTeamMemberStatus.email,
            status: changeTeamMemberStatus.status,
        },
            {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            }).then(async (Res) => {
                callback(Res.data)
            }).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du changement du statut du membre de l'équipe, veuillez réessayer." }
                }))
            })
        get().setIsFetching(false);
    },
    changeTeamMemberDetails: async (callback: (response: any) => void, changeTeamMemberDetails: ChangeTeamMemberDetailsRequest) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de la modification des informations du membre de l’équipe, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CHANGE_TEAM_MEMBER_DETAILS, changeTeamMemberDetails, {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            }).then(async (Res) => {
                callback(Res.data)
            }).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de la modification des informations du membre de l’équipe, veuillez réessayer." }
                }))
            })
        }
        get().setIsFetching(false);
    },

    getProfessionalAccountDetails: async () => {
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de la récupération des informations du compte, veuillez réessayer." }
            }))
            get().logoutFront();
        } else await instance.post(GET_ACCOUNT_DETAILS, {},
            {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            }).then(async (Res) => {
                set(state => ({ ...state, professionalAccount: Res.data }))
            }).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de la récupération des informations du compte, veuillez réessayer." }
                }))
            })
    },

    generateOtpM2t: async (request: GenerateOtpM2TRequest, callback: (response: GenerateOtpM2TResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de l’envoi du code OTP par SMS, veuillez réessayer." }
            }))
        } else {
            await instance.post(GENERATE_M2T_OTP, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    if (process.env.REACT_APP_MY_ENVIRONMENT === "dev" || process.env.REACT_APP_MY_ENVIRONMENT === "int") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "M2T Testing Otp valeur: " + Res.data.otp, description: "M2T Testing Otp valeur: " + Res.data.otp }
                        }))
                    }
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de l’envoi du code OTP par SMS, veuillez réessayer." }
                    }))
                })

        }
        get().setIsFetching(false);
    },

    handleCashInCash: async (request: CashInCashRequest, callback: (response?: CashInCashResponse, errorCode?: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
            }))
        } else {
            await instance.post(CASH_IN_CASH, {
                amountBeforeFees: request.amountBeforeFees,
                otp: request.otp,
                transactionId: request.transactionId,
                method: request.method
            },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "M2T_WRONG_OTP") {
                        callback(undefined, Exp.response.data.returnCode);
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
                        }))
                    }
                })

        }
        get().setIsFetching(false);
    },

    getPendingTransactionsCount: async (callBack: (isLessThanLimit: boolean) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
            }))
        } else {
            await instance.post(PENDING_COUNT, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(() => {
                    callBack(true);
                }).catch(Exp => {
                    if (Exp?.response?.data?.returnCode !== "TOO_MANY_PENDING_TRANSACTIONS")
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }

                        }))
                    else callBack(false);
                }
                )
        }
        get().setIsFetching(false);
    },

    generateRibDocument: async (callback: (response: RibDocumentResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du téléchargement de l’attestation RIB, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_RIB_DOCUMENT, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du téléchargement de l’attestation RIB, veuillez réessayer." }
                    }))
                })

        }
        get().setIsFetching(false);
    },

    getBankBeneficiaries: async (request: GetBankBeneficiariesPageRequest, callback: (beneficiariesList: BankBeneficiaryType[], isLastPage: boolean) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_BANK_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data.professionalBeneficiaryResponseList, Res.data.isLastPage);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    requestAddBankBeneficiary: async (request: RequestAddBankBeneficiaryRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REQUEST_ADD_BANK_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce RIB existe dans votre liste de bénéficiaire." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_CREATION_REQUEST_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce RIB existe dans votre liste des demandes." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_CREATION_REQUEST_LIMIT_REACHED") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Vous avez trop de demandes en attentes." }
                        }));
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    addBankBeneficiary: async (request: AddBankBeneficiaryRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(ADD_BANK_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce RIB existe dans votre liste de bénéficiaire." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_LIMIT_REACHED") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Vous avez atteint le nombre maximal de bénéficiaires autorisés." }
                        }));
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    deleteBankBeneficiary: async (request: DeleteBankBeneficiaryRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(DELETE_BANK_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getSendMoneyToBankFees: async (callback: (fees: FeeObjectType[]) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_SEND_MONEY_TO_BANK_FEES, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data.fees);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    sendMoneyToBank: async (request: SendMoneyToBankRequest, callback: (errorCode?: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(SEND_MONEY_TO_BANK, { ...request },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "M2T_WRONG_OTP") {
                        callback(Exp.response.data.returnCode);
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }));
                    }
                })
        }
        get().setIsFetching(false);
    },

    requestSendMoneyToBank: async (request: RequestSendMoneyToBankRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REQUEST_SEND_MONEY_TO_BANK, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    handleCashoutCash: async (request: CashOutRequest, callback: (response?: CashOutResponse, errorCode?: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
            }))
        } else {
            await instance.post(CASH_OUT_CASH, {
                amountBeforeFees: request.amountBeforeFees,
                otp: request.otp,
                transactionId: request.transactionId,
                method: request.method
            },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "M2T_WRONG_OTP") {
                        callback(undefined, Exp.response.data.returnCode);
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
                        }))
                    }
                })

        }
        get().setIsFetching(false);
    },

    getCashOutFees: async (request: GetCashOutFeesRequest, callBack: (response: GetCashOutFeesResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
            }))
        } else {
            await instance.post(GET_FEES_CASHOUT_CASH, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callBack(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
                    }))
                })

        }
        get().setIsFetching(false);
    },

    getTransactionsHistory: async (callback?: (hasMore: boolean) => void, limit: number = 5) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
            }))
        } else {
            await instance.post(TRANSACTIONS_HISTORY, {
                limit: limit
            },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (response) => {
                    callback && callback(limit === response.data.totalTransactions);
                    set(state => ({
                        ...state, transactions: response.data.transactions,
                        totalTransactions: response.data.totalTransactions,
                        transactionLimit: limit + 5
                    }))
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getPendingTransactionsHistory: async (callback?: (isSuccess: boolean) => void, limit: number = 10) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
            }))
        } else {
            await instance.post(PENDING_TRANSACTIONS_HISTORY, {
                limit: limit
            },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (response) => {
                    set(state => ({
                        ...state, pendingTransactions: response.data.pendingTransactions,
                        totalPendingTransactionsPaginated: response.data.totalPendingTransactionsPaginated,
                        totalPendingTransactions: response.data.totalPendingTransactions,
                        pendingTransactionLimit: limit + 10
                    }))
                    callback && callback(true);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Une erreur s'est produite !", description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getWalletBeneficiaries: async (request: GetWalletBeneficiariesPageRequest, callback: (beneficiariesList: WalletBeneficiaryType[], isLastPage: boolean) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_WALLET_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data.professionalBeneficiaryResponseList, Res.data.isLastPage);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    checkBeneficiaryHasSkypayAccount: async (request: CheckBeneficiaryHasSkypayAccountRequest, callback: (hasAccount: boolean) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CHECK_BENEFICIARY_HAS_SKYPAY_ACCOUNT, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data.phoneExists);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    requestAddWalletBeneficiary: async (request: RequestAddWalletBeneficiaryRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REQUEST_ADD_WALLET_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce numéro de téléphone existe dans votre liste de bénéficiaire." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_CREATION_REQUEST_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce numéro de téléphone existe dans votre liste des demandes." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_CREATION_REQUEST_LIMIT_REACHED") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Vous avez trop de demandes en attentes." }
                        }));
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    addWalletBeneficiary: async (request: AddWalletBeneficiaryRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(ADD_WALLET_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce numéro de téléphone existe dans votre liste de bénéficiaire." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_LIMIT_REACHED") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Vous avez atteint le nombre maximal de bénéficiaires autorisés." }
                        }));
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    deleteWalletBeneficiary: async (request: DeleteWalletBeneficiaryRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(DELETE_WALLET_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getSendMoneyToWalletFees: async (callback: (fees: FeeObjectType[]) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_SEND_MONEY_TO_WALLET_FEES, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data.fees);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    sendMoneyToWallet: async (request: SendMoneyToWalletRequest, callback: (errorCode?: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            const amount = Number(request.amount);
            await instance.post(SEND_MONEY_TO_WALLET, { ...request, amount },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "M2T_WRONG_OTP") {
                        callback(Exp.response.data.returnCode);
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }));
                    }
                })
        }
        get().setIsFetching(false);
    },

    requestSendMoneyToWallet: async (request: RequestSendMoneyToWalletRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            const amount = Number(request.amount);
            await instance.post(REQUEST_SEND_MONEY_TO_WALLET, { ...request, amount },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getSkypayBeneficiaries: async (request: GetSkypayBeneficiariesPageRequest, callback: (beneficiariesList: SkypayBeneficiaryType[], isLastPage: boolean) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_SKYPAY_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data.professionalBeneficiaryResponseList, Res.data.isLastPage);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getSkypayBeneficiaryInfos: async (request: GetSkypayBeneficiaryInfosRequest, callback: (beneficiary?: GetSkypayBeneficiaryInfosResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_SKYPAY_BENEFICIARY_INFOS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    if (Exp.response && Exp.response.data.returnCode === "CLIENT_NOT_FOUND") {
                        callback(undefined);
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    requestAddSkypayBeneficiary: async (request: RequestAddSkypayBeneficiaryRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REQUEST_ADD_SKYPAY_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce numéro de téléphone existe dans votre liste de bénéficiaire." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_CREATION_REQUEST_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce numéro de téléphone existe dans votre liste des demandes." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_CREATION_REQUEST_LIMIT_REACHED") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Vous avez trop de demandes en attentes." }
                        }));
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    addSkypayBeneficiary: async (request: AddSkypayBeneficiaryRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(ADD_SKYPAY_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce numéro de téléphone existe dans votre liste de bénéficiaire." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_LIMIT_REACHED") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Vous avez atteint le nombre maximal de bénéficiaires autorisés." }
                        }));
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    deleteSkypayBeneficiary: async (request: DeleteSkypayBeneficiaryRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(DELETE_SKYPAY_BENEFICIARIES, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    sendMoneyToSkypay: async (request: SendMoneyToSkypayRequest, callback: (errorCode?: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            const amount = Number(request.amount);
            await instance.post(SEND_MONEY_TO_SKYPAY, { ...request, amount },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "M2T_WRONG_OTP") {
                        callback(Exp.response.data.returnCode);
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }));
                    }
                })
        }
        get().setIsFetching(false);
    },

    requestSendMoneyToSkypay: async (request: RequestSendMoneyToSkypayRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            const amount = Number(request.amount);
            await instance.post(REQUEST_SEND_MONEY_TO_SKYPAY, { ...request, amount },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getRequestsCount: async (callback: (response: RequestsCountType) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_REQUESTS_COUNT, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getAddSkypayBeneficiaryDemandesPage: async (request: GetAddSkypayBeneficiaryDemandesPageRequest, callback: (response: GetAddSkypayBeneficiaryDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_ADD_SKYPAY_BENEFICIARIES_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getAddBankBeneficiaryDemandesPage: async (request: GetAddBankBeneficiaryDemandesPageRequest, callback: (response: GetAddBankBeneficiaryDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_ADD_BANK_BENEFICIARIES_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getAddWalletBeneficiaryDemandesPage: async (request: GetAddWalletBeneficiaryDemandesPageRequest, callback: (response: GetAddWalletBeneficiaryDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_ADD_WALLET_BENEFICIARIES_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getSkypayTransactionDemandesPage: async (request: GetSkypayTransactionDemandesPageRequest, callback: (response: GetSkypayTransactionDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_SKYPAY_TRANSACTION_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getBankTransactionDemandesPage: async (request: GetBankTransactionDemandesPageRequest, callback: (response: GetBankTransactionDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_BANK_TRANSACTION_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getWalletTransactionDemandesPage: async (request: GetWalletTransactionDemandesPageRequest, callback: (response: GetWalletTransactionDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_WALLET_TRANSACTION_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    acceptAddSkypayBeneficiaryDemande: async (request: { id: number }, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(ACCEPT_ADD_SKYPAY_BENEFICIARIES_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce RIB existe dans votre liste de bénéficiaire." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_LIMIT_REACHED") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Vous avez atteint le nombre maximal de bénéficiaires autorisés." }
                        }));
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    acceptAddBankBeneficiaryDemande: async (request: { id: number }, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(ACCEPT_ADD_BANK_BENEFICIARIES_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce numéro de téléphone existe dans votre liste de bénéficiaire." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_LIMIT_REACHED") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Vous avez atteint le nombre maximal de bénéficiaires autorisés." }
                        }));
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    acceptAddWalletBeneficiaryDemande: async (request: { id: number }, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(ACCEPT_ADD_WALLET_BENEFICIARIES_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_ALREADY_EXISTS") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Ce nom ou ce numéro de téléphone existe dans votre liste de bénéficiaire." }
                        }));
                    } else if (Exp.response.data.returnCode === "PROFESSIONAL_BENEFICIARY_LIMIT_REACHED") {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Échec d'ajout du bénéficiaire.", description: "Vous avez atteint le nombre maximal de bénéficiaires autorisés." }
                        }));
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }))
                    }
                })
        }
        get().setIsFetching(false);
    },

    acceptSkypayTransactionDemande: async (request: { id: number }, callback: (errorCode?: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(ACCEPT_SKYPAY_TRANSACTION_REQUEST, { ...request },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "M2T_WRONG_OTP") {
                        callback(Exp.response.data.returnCode);
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }));
                    }
                })
        }
        get().setIsFetching(false);
    },

    acceptBankTransactionDemande: async (request: { id: number }, callback: (errorCode?: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(ACCEPT_BANK_TRANSACTION_REQUEST, { ...request },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "M2T_WRONG_OTP") {
                        callback(Exp.response.data.returnCode);
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }));
                    }
                })
        }
        get().setIsFetching(false);
    },

    acceptWalletTransactionDemande: async (request: { id: number }, callback: (errorCode?: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(ACCEPT_WALLET_TRANSACTION_REQUEST, { ...request },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    if (Exp.response.data.returnCode === "M2T_WRONG_OTP") {
                        callback(Exp.response.data.returnCode);
                    } else {
                        set(state => ({
                            ...state,
                            globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                        }));
                    }
                })
        }
        get().setIsFetching(false);
    },

    rejectAddSkypayBeneficiaryDemande: async (request: { id: number }, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REJECT_ADD_SKYPAY_BENEFICIARIES_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    rejectAddBankBeneficiaryDemande: async (request: { id: number }, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REJECT_ADD_BANK_BENEFICIARIES_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    rejectAddWalletBeneficiaryDemande: async (request: { id: number }, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REJECT_ADD_WALLET_BENEFICIARIES_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    rejectSkypayTransactionDemande: async (request: { id: number }, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REJECT_SKYPAY_TRANSACTION_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    rejectBankTransactionDemande: async (request: { id: number }, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REJECT_BANK_TRANSACTION_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    rejectWalletTransactionDemande: async (request: { id: number }, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(REJECT_WALLET_TRANSACTION_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },


    generateQrCode: async () => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalError: { hasError: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GENERATE_QR_CODE, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then((Res) => {
                    set((state: StoreStateType) => ({ ...state, qrCode: Res.data.qrCode }))
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalError: { hasError: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    downloadQrCodeDocument: async (callback: (response: QrCodeDocumentResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalError: { hasError: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(DOWNLOAD_QR_CODE, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then((Res) => {
                    callback(Res.data)
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalError: { hasError: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getUserActiveRequestsCount: async (callback: (response: RequestsCountType) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_USER_ACTIVE_REQUESTS_COUNT, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getUserActiveAddSkypayBeneficiaryDemandesPage: async (request: GetUserActiveAddSkypayBeneficiaryDemandesPageRequest, callback: (response: GetAddSkypayBeneficiaryDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_USER_ACTIVE_ADD_SKYPAY_BENEFICIARIES_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getUserActiveAddBankBeneficiaryDemandesPage: async (request: GetUserActiveAddBankBeneficiaryDemandesPageRequest, callback: (response: GetAddBankBeneficiaryDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_USER_ACTIVE_ADD_BANK_BENEFICIARIES_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getUserActiveAddWalletBeneficiaryDemandesPage: async (request: GetUserActiveAddWalletBeneficiaryDemandesPageRequest, callback: (response: GetAddWalletBeneficiaryDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_USER_ACTIVE_ADD_WALLET_BENEFICIARIES_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getUserActiveSkypayTransactionDemandesPage: async (request: GetUserActiveSkypayTransactionDemandesPageRequest, callback: (response: GetSkypayTransactionDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_USER_ACTIVE_SKYPAY_TRANSACTION_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getUserActiveBankTransactionDemandesPage: async (request: GetUserActiveBankTransactionDemandesPageRequest, callback: (response: GetBankTransactionDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_USER_ACTIVE_BANK_TRANSACTION_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getUserActiveWalletTransactionDemandesPage: async (request: GetUserActiveWalletTransactionDemandesPageRequest, callback: (response: GetWalletTransactionDemandesPageResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_USER_ACTIVE_WALLET_TRANSACTION_REQUESTS, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback(Res.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    cancelAddSkypayBeneficiaryDemande: async (request: CancelAddSkypayBeneficiaryDemandeRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CANCEL_ADD_SKYPAY_BENEFICIARIES_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    cancelAddBankBeneficiaryDemande: async (request: CancelAddBankBeneficiaryDemandeRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CANCEL_ADD_BANK_BENEFICIARIES_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    cancelAddWalletBeneficiaryDemande: async (request: CancelAddWalletBeneficiaryDemandeRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CANCEL_ADD_WALLET_BENEFICIARIES_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    cancelSkypayTransactionDemande: async (request: CancelSkypayTransactionDemandeRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CANCEL_SKYPAY_TRANSACTION_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    cancelBankTransactionDemande: async (request: CancelBankTransactionDemandeRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CANCEL_BANK_TRANSACTION_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    cancelWalletTransactionDemande: async (request: CancelWalletTransactionDemandeRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CANCEL_WALLET_TRANSACTION_REQUEST, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    getSwitchStatus: async (callback?: () => void) => {
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CHECK_SWITCH_STATUS, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    set((state: StoreStateType) => ({ ...state, switchStatus: getSwitchStatusByCode(Res.data.statusCode), hasSwitchStatusBeenTriedFetching: true }));
                    callback && callback();
                }).catch(Exp => {
                    set((state: StoreStateType) => ({ ...state, switchStatus: SwitchStatus.UNKNOWN, hasSwitchStatusBeenTriedFetching: true }));
                })
        }
    },

    enrollToSwitchGenerateOtp: async (callback: (referenceNumber: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(SWITCH_ENROLEMENT_GENERATE_OTP, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback && callback(Res.data.referenceNumber);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de l'envoie du SMS. Veuillez réessayer plus tard." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    confirmEnrollmentToSwitch: async (otp: string, referenceNumber: string, callback: (errorCode?: string) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(SWITCH_CONFIRM_ENROLEMENT, { otp, referenceNumber },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback && callback();
                }).catch(Exp => {
                    callback(Exp.response.data.returnCode)
                })
        }
        get().setIsFetching(false);
    },

    checkOffUsDestination: async (targetPhoneNumber: string, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec du traitement, veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                CHECK_OFFUS_DESTINATION,
                { targetPhoneNumber },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }
            ).then(async (Res) => {
                callback && callback();
            }
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, un problème est survenu !",
                        description: "Désolé pour cet inconvénient. Veuillez réessayer dans quelques instants."
                    }
                }))
            }
            )
        }
        get().setIsFetching(false);
    },

    getInternalSwitchStatus: async (callback?: () => void) => {
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(CHECK_INTERNAL_SWITCH_STATUS, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    set((state: StoreStateType) => ({ ...state, internalSwitchStatus: Res.data.statusCode, hasInternalSwitchStatusBeenTriedFetching: true }));
                    callback && callback();
                }).catch(Exp => {
                    set((state: StoreStateType) => ({ ...state, internalSwitchStatus: InternalSwitchStatus.NOTACTIVE, hasInternalSwitchStatusBeenTriedFetching: true }));
                })
        }
    },

    enrollToInternalSwitch: async (callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(INTERNAL_SWITCH_ENROLEMENT, {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback && callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de l'opération. Veuillez réessayer plus tard." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    updateAvatar: async (request: UpdateAvatarRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du traitement, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(UPDATE_AVATAR, request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    },
                }).then(async (Res) => {
                    callback && callback();
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de l'opération. Veuillez réessayer plus tard." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    fetchAllDeliveryMembers: async (request: FetchAllDeliveryMembersRequest, callback: (response: FetchAllDeliveryMembersResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Une erreur est survenue. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(GET_ALL_DELIVERY_MEMBERS,
                {
                    ...request,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }).then(async (response) => {
                    callback(response.data);
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: {
                            isOpen: true,
                            title: "Oups, une erreur s'est produite !",
                            description: "Échec du chargement de la liste des livreurs. Veuillez réessayer."
                        }
                    }))
                })

        }
        get().setIsFetching(false);
    },

    createDeliveryMember: async (request: CreateDeliveryMemberRequest, callBack: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({ ...state, globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Création du membre échouée. Veuillez réessayer." } }))
            get().logoutFront();
        }
        else
            await instance.post(CREATE_DELIVERY_MEMBER,
                {
                    deliveryAgentPhoneNumber: request.phoneNumber,
                    city: request.city
                }, {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            })
                .then(response => {
                    set(state => ({ ...state, globalDialog: { isOpen: true, title: "Création du membre réussie !", description: "Membre créé avec succès" } }))
                    callBack();
                })
                .catch(Exp => {
                    if (Exp.response.data.returnCode === "CLIENT_NOT_FOUND") {
                        set(state => ({ ...state, globalDialog: { isOpen: true, title: "Numéro non associé", description: "Aucun compte Skypay actif n'est associé à ce numéro de téléphone." } }))
                    }
                    else
                        set(state => ({ ...state, globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Création du membre échouée. Veuillez réessayer." } }))
                })
        get().setIsFetching(false);
    },

    changeDeliveryMemberStatus: async (request: ChangeDeliveryMemberStatusRequest, callback: (response: any) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du changement du statut du membre, veuillez réessayer." }
            }))
            get().logoutFront();
        } else await instance.post(UPDATE_DELIVERY_MEMBER_STATUS,
            {
                deliveryAgentUuid: request.uuid,
                status: request.status
            },
            {
                headers: {
                    Authorization: 'Bearer ' + cachedData.token
                }
            }).then(async (response) => {
                callback(response.data)
            }).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec du changement du statut du membre, veuillez réessayer." }
                }))
            })
        get().setIsFetching(false);
    },

    changeDeliveryMemberDetails: async (request: ChangeDeliveryMemberDetailsRequest, callback: () => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state,
                globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de la modification des informations du membre, veuillez réessayer." }
            }))
            get().logoutFront();
        } else {
            await instance.post(UPDATE_DELIVERY_MEMBER,
                {
                    deliveryAgentUuid: request.uuid,
                    city: request.city,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }).then(async (response) => {
                    callback()
                }).catch(Exp => {
                    set(state => ({
                        ...state,
                        globalDialog: { isOpen: true, title: "Oups, un problème est survenu !", description: "Échec de la modification des informations du membre, veuillez réessayer." }
                    }))
                })
        }
        get().setIsFetching(false);
    },

    downloadReportDocument: async (request: ReportDocumentRequest, callback: (response: ReportDocumentResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec du téléchargement de l'historique. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                GENERATE_REPORT_DOCUMENT,
                request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }
            ).then(async (response) => callback(response.data)
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, une erreur s'est produite !",
                        description: "Échec du téléchargement de l'historique. Veuillez réessayer."
                    }
                }))
            });
        }
        get().setIsFetching(false);
    },
    getReversementSectionKPIOverview: async (request: FetchReversementSectionKPIOverviewRequest, callback: (response: any) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec du chargement de l’aperçu des reversements. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                GET_REVERSEMENT_KPI_OVERVIEW,
                { dateInterval: checkDates([request.dateInterval[0], addOneDay(request.dateInterval[1])]) },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }
            ).then(async (response) => callback(response.data)
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, un problème est survenu !",
                        description: "Échec du chargement de l’aperçu des reversements. Veuillez réessayer."
                    }
                }))
            });
        }
        get().setIsFetching(false);
    },
    getQrCodeSectionKPIOverview: async (request: FetchQrCodeSectionKPIOverviewRequest, callback: (response: any) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec du chargement de l’aperçu des encaissements via code QR. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                GET_QR_CODE_KPI_OVERVIEW,
                { dateInterval: checkDates([request.dateInterval[0], addOneDay(request.dateInterval[1])]) },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }
            ).then(async (response) => callback(response.data)
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, un problème est survenu !",
                        description: "Échec du chargement de l’aperçu des encaissements via code QR. Veuillez réessayer."
                    }
                }))
            });
        }
        get().setIsFetching(false);
    },
    getActivityPerProfessionalDeliveryAgent: async (request: FetchActivityPerProfessionalDeliveryAgentRequest, callback: (response: any) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec du chargement des reversements et encaissements par livreur. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                GET_ACTIVITY_PER_PROFESSIONAL_DELIVERY_AGENT,
                { dateInterval: checkDates([request.dateInterval[0], addOneDay(request.dateInterval[1])]) },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }
            ).then(async (response) => callback(response.data)
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, un problème est survenu !",
                        description: "Échec du chargement des reversements et encaissements par livreur. Veuillez réessayer."
                    }
                }))
            });
        }
        get().setIsFetching(false);
    },
    fetchDeliveryFinancialSituation: async (request: FetchDeliveryFinancialSituationRequest, callBack: (response: FetchDeliveryFinancialSituationResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec du chargement les informations financières de ce livreur. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                GET_DELIVERY_FINANCIAL_SITUATION,
                { 
                    deliveryAgentUuid: request.uuid,
                    dateInterval: checkDates([request.dateInterval[0], addOneDay(request.dateInterval[1])]) 
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }
            ).then(async (response) => callBack(response.data)
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, un problème est survenu !",
                        description: "Échec du chargement les informations financières de ce livreur. Veuillez réessayer."
                    }
                }))
            });
        }
        get().setIsFetching(false);
    },

    fetchAllDeliveryMemberCollections: async (request: FetchAllDeliveryMemberCollectionsRequest, callback: (response: FetchAllDeliveryMemberCollectionsResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec du chargement de l'historique des encaissements. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                GET_ALL_DELIVERY_MEMBER_COLLECTIONS, 
                {
                    ...request,
                    dateInterval: checkDates([request.dateInterval[0], addOneDay(request.dateInterval[1])])
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }
            ).then(async (response) => callback(response.data)
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, une erreur s'est produite !",
                        description: "Échec du chargement de l'historique des encaissements. Veuillez réessayer."
                    }
                }))
            });
        }
        get().setIsFetching(false);
    },
    
    cancelDeliveryMemberCollection: async (request: cancelDeliveryMemberCollectionRequest, callback: (response: cancelDeliveryMemberCollectionResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec de l'annulation de l'encaissement. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                CANCEL_DELIVERY_MEMBER_COLLECTION, 
                request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }
            ).then(async (response) => callback(response.data)
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, une erreur s'est produite !",
                        description: "Échec de l'annulation de l'encaissement. Veuillez réessayer."
                    }
                }))
            });
        }
        get().setIsFetching(false);
    },

    fetchAllDeliveryMemberReversments: async (request: FetchAllDeliveryMemberReversmentsRequest, callback: (response: FetchAllDeliveryMemberReversmentsResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec du chargement de l'historique des reversements. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                GET_ALL_DELIVERY_MEMBER_REVERSMENTS, 
                {
                    ...request,
                    dateInterval: checkDates([request.dateInterval[0], addOneDay(request.dateInterval[1])])
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }
            ).then(async (response) => callback(response.data)
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, une erreur s'est produite !",
                        description: "Échec du chargement de l'historique des reversements. Veuillez réessayer."
                    }
                }))
            });
        }
        get().setIsFetching(false);
    },
    
    fetchReversmentsIncludedCollections: async (request: FetchReversmentsIncludedCollectionsRequest, callback: (response: FetchReversmentsIncludedCollectionsResponse) => void) => {
        get().setIsFetching(true);
        const cachedData = securelyRetrieveData("loggedUser");
        if (cachedData === undefined) {
            set(state => ({
                ...state, globalDialog: {
                    isOpen: true,
                    title: "Oups, un problème est survenu !",
                    description: "Échec du chargement de l'historique des encaissements inclus. Veuillez réessayer."
                }
            }))
            get().logoutFront();
        } else {
            await instance.post(
                GET_REVERSEMENT_INCLUDED_COLLECTIONS, 
                request,
                {
                    headers: {
                        Authorization: 'Bearer ' + cachedData.token
                    }
                }
            ).then(async (response) => callback(response.data)
            ).catch(Exp => {
                set(state => ({
                    ...state,
                    globalDialog: {
                        isOpen: true,
                        title: "Oups, une erreur s'est produite !",
                        description: "Échec du chargement de l'historique des Encaissements inclus. Veuillez réessayer."
                    }
                }))
            });
        }
        get().setIsFetching(false);
    },
}));

export const {
    getState: getStore,
    setState: setStore
} = useStore;

export default useStore